module.exports = __webpack_public_path__ + "media/images/icon-help-30bacd3ef26ecdf31ee776dd0ef1bbf8.svg";